// SHCT-520 — decode HTML entities in a plain-text string for display.
//
// The list-row "preview" strings come from the backend already tag-stripped, but
// with HTML entities still ENCODED (a user-typed `<`, `&`, `>` is persisted as
// `&lt;`, `&amp;`, `&gt;` by the WYSIWYG editor, and the server's preview()
// strips tags without unescaping). Rendered as a React text node they'd show the
// raw `&lt;`. Decoding here restores the authored characters.
//
// Uses a detached <textarea>: its content model is RCDATA, so character
// references are decoded but NO markup is parsed into elements and no event
// handlers run — safe for untrusted input (unlike `div.innerHTML`).
export function decodeHtmlEntities(input: string): string {
  if (!input) return '';
  const el = document.createElement('textarea');
  el.innerHTML = input;
  return el.value;
}
